import styled from '@emotion/styled';
import { mediaQueries } from '../../../../style/global-style';

export const StyledComponentWrapper = styled.div`
    padding: 13px 0px;
    z-index: 1;

    @media ${mediaQueries.phone} {
        padding: 0;
    }

    path {
        color: white;
    }
`;

export const StyledGDRPTextStyle = styled.div`
    color: white;
    font-size: 11px;
    padding: 5px 0px;

    @media ${mediaQueries.phone} {
        padding-top: 6px;
        text-align: center;
    }
    @media ${mediaQueries.tabletAndUp} {
        padding-left: 42px;
    }

    > a {
        color: white;
        cursor: pointer;
        text-decoration: underline;
    }
`;

export const StyledEmailWrapper = styled.div`
    overflow: hidden;
    position: relative;
    margin-top: 15px;
    width: 65%;
`;

export const StyledHeaderText = styled.div`
    align-items: center;
    display: flex;

    @media ${mediaQueries.phone} {
        text-align: center;
    }
`;

export const StyledText = styled.p`
    color: white;
    margin: 0;
    font-size: 18px;
    line-height: 22px;
    flex: 1 1 auto;
    font-family: Arial, Helvetica, sans-serif;

    @media ${mediaQueries.phone} {
        font-size: 19px;
    }
`;

export const StyledError = styled.div`
    color: white;
    margin-top: 5px;
    font-size: 15px;
    padding-left: 42px;

    @media ${mediaQueries.phone} {
        padding-left: 0;
    }
`;
